// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Gsx7L","overflowing":"ReadFullNote_overflowing__2KCK_"};